<div class="container not-fond-container" appMousemove>
  <img id="cloud" class="cloud-group" src="../../assets/img/clouds/cloud-group-2.svg" alt="image">
  <img class="not-found-bg" src="assets/img/info.png" alt="image">
  <div class="main-title">
    ERROR 404
  </div>
  <div class="button" (click)="back()">
    Назад
  </div>
  <div class="info-img not-fond-img">
    <div id="scooter" class="info-scooters-container">
      <img class="info-scooter-left" src="../../assets/img/info-scooter-left.svg"
           alt="image">
      <img class="info-scooter-right" src="../../assets/img/info-scooter-right.svg"
           alt="image">
    </div>
  </div>
</div>
